<template>
  <v-footer app inset class="pa-3" absolute>
    <span id="sb-version-num">{{
      commitHash !== ''
        ? `v${version} (${commitHash.substr(0, 8)})`
        : `v${version}`
    }}</span>
    <v-spacer />
    <a href="https://www.sphereco.com/" target="_blank">
      SPHERE Technology Solutions
    </a>
  </v-footer>
</template>

<script>
/**
 * This component is used for the footer of the site
 */
export default {
  name: 'TheFooter',
  data() {
    return {
      version: '0.0',
      commitHash: typeof __COMMIT_HASH__ === 'undefined' ? '' : __COMMIT_HASH__,
    };
  },
  mounted() {
    const versionInputElem = document.getElementById('sb-version');
    if (versionInputElem) {
      this.version = versionInputElem.value;
    }
  },
};
</script>

<style>
@import '../static/css/Components/Footer.css';
</style>
